<template>
    <section>
        <b-overlay :show="loading" rounded="sm">
            <chart :options="chartOptions"  ref="chart"></chart>
            <span>Total de rides: {{ totalRides }}</span>
            <br>
            <span v-if="totalRidesLastYear != null">Total de rides año anterior: {{ totalRidesLastYear }}</span>
        </b-overlay>
    </section>
</template>

<script>
    import {Chart} from 'highcharts-vue'
    import Highcharts from 'highcharts'
    import exportingInit from 'highcharts/modules/exporting'
    exportingInit(Highcharts)

    export default {
        name: "TimeLineChart",
        components:{Chart},
        props: {
            data: {
                type : Object,
                required: true
            }
        },
        data(){
            let seriesExample = [{
                name:"",
                data:[]
            }];
            return {
                title: '',
                currency:"",
                totalRides:0,
                totalRidesLastYear: null,
                showing:"all",
                originalCategories:[],
                originalSeries:[],
                loading:false,
                exporting: {
                    enabled: true
                },
                chartOptions:{
                    title: {
                        text: 'Linea de tiempo de servicios por fecha de venta'
                    },
                    tooltip: {
                        formatter: function(tooltip) {
                            let original = tooltip.defaultFormatter.call(this, tooltip);
                            let data     = this.point

                            if (data.groupBy == 'month') {
                                original[0]  = `<span style="font-size: 10px">${data.name} ${data.year}</span><br/>`;
                            } else {
                                original[0]  = `<span style="font-size: 10px">${data.customName}</span><br/>`;
                            }
                           
                            const total = data.stats != null ? data.stats.total : 0;
                            original.push(`<span style="color:#7cb5ec">●</span> Total: <b>$ ${total}</b><br/>`)
                            return original
                        }
                    },
                    yAxis: {
                        title: {
                            text: 'Servicios'
                        }
                    },
                    exporting:{
                        buttons:{
                            menuItems:["viewFullscreen"]
                        }
                    },
                    chart:{
                        type: ''
                    },
                    xAxis:{
                        type: 'category',
                        categories:[],
                        max:null,
                    },
                    series: seriesExample
                }
            }
        },
        methods:{
            number_format (number, decimals, dec_point, thousands_sep) {
                // Strip all characters but numerical ones.
                number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
                var n = !isFinite(+number) ? 0 : +number,
                prec  = !isFinite(+decimals) ? 0 : Math.abs(decimals),
                sep   = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
                dec   = (typeof dec_point === 'undefined') ? '.' : dec_point,
                s     = '',
                toFixedFix = function (n, prec) {
                    var k = Math.pow(10, prec);
                    return '' + Math.round(n * k) / k;
                };
                
                // Fix for IE parseFloat(0.55).toFixed(0) = 0;
                s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
                if (s[0].length > 3) {
                s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
                }

                if ((s[1] || '').length < prec) {
                s[1] = s[1] || '';
                s[1] += new Array(prec - s[1].length + 1).join('0');
                }

                return s.join(dec);
            },
        },
        watch:{
            showing() {
                if(this.showing >0 ){
                    if((this.showing)<= (this.chartOptions.xAxis.categories.length-1) ){
                        this.chartOptions.xAxis.max= this.showing;
                    }else{
                        this.showing = 'all';
                    }
                }else{
                    this.chartOptions.xAxis.max = null;
                }
            },
            data: {
                immediate: true,
                handler(newData) {
                    if (newData && !newData.then) {  // Asegúrate de que no sea una promesa
                        this.totalRides                    = this.number_format(newData.total, 0, '.', ',');
                        this.originalCategories            = newData.categories;
                        this.originalSeries                = newData.series;
                        this.title                         = newData.title;
                        this.chartOptions.series           = newData.series;
                        this.chartOptions.xAxis.categories = newData.categories;
                        this.chartOptions.title.text       = newData.title;

                        if (newData.totalLastYear != null) {
                            this.totalRidesLastYear = this.number_format(newData.totalLastYear, 0, '.', ',');
                        }
                    }
                }
            }
        },
        mounted() {

            this.totalRides = this.number_format(this.data.total,0,'.',',');
            if (this.data.totalLastYear != null) {
                this.totalRidesLastYear = this.number_format(this.data.totalLastYear,0,'.',',');
            }    
            
            this.originalCategories = this.data.categories;
            this.originalSeries     = this.data.series;
            this.title              = this.data.title;

            this.chartOptions.series           = this.data.series;
            this.chartOptions.xAxis.categories = this.data.categories;
            this.chartOptions.title.text       = this.data.title
        }
    }

</script>